import { render } from "./ChooseLangView.vue?vue&type=template&id=06992568&scoped=true"
import script from "./ChooseLangView.vue?vue&type=script&lang=js"
export * from "./ChooseLangView.vue?vue&type=script&lang=js"

import "./ChooseLangView.vue?vue&type=style&index=0&id=06992568&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06992568"]])

export default __exports__